// vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Fragment, lazy, Suspense, useMemo } from 'react';

import { cssMap, cx, jsx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { encodeAdf } from '@atlassian/conversation-assistant-content-transformer/adf-encoder';

import { StatusCitation } from '../ai-answer-body/ai-answer-result/rendered/status-citation';

const styles = cssMap({
	container: {
		minHeight: '106px',
		paddingTop: token('space.100'),
		paddingRight: token('space.300'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.300'),
	},
	containerStylesWithoutStreamingExpand: {
		maxHeight: '160px',
		overflow: 'hidden',
	},
});

const ReactRenderer = lazy(() =>
	import(/* webpackChunkName: "@atlaskit-internal_.renderer" */ '@atlaskit/renderer').then(
		({ ReactRenderer }) => {
			return {
				default: ReactRenderer,
			};
		},
	),
);

export const AIAnswerLoadingStream: ({ markdown }: { markdown: string }) => JSX.Element = ({
	markdown,
}: {
	markdown: string;
}) => {
	const docContent = useMemo(() => encodeAdf(markdown, false), [markdown]);

	return (
		<Box
			xcss={cx(
				styles.container,
				!fg('kd_sain_enable_expand_when_streaming') && styles.containerStylesWithoutStreamingExpand,
			)}
		>
			<Suspense fallback={<Fragment />}>
				<ReactRenderer
					document={docContent}
					nodeComponents={{
						status: (props) => <StatusCitation {...props} />,
						// Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
						// Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
						...(!fg('hybrid_orchestrator_enable_image_search')
							? {
									media: () => <Fragment />,
									mediaSingle: () => <Fragment />,
								}
							: undefined),
					}}
				/>
			</Suspense>
		</Box>
	);
};
